import type { DTOSubscriptionBenefitResponse } from 'src/apis/dto/DTOSubscription';
import { client } from 'src/utils/api';

export const fetchSubscriptionProductsBenefit = async (
  productId: string
): Promise<DTOSubscriptionBenefitResponse> => {
  const response = await client.get<DTOSubscriptionBenefitResponse>(
    `/api/v1/subscriptions/products/${productId}/benefit`
  );
  return response.data;
};
